export type GlossaryScanEstimate = {
  creditCost: number;
  freshCreditCost?: number;
  chapterCount?: number;
  reusableRunId?: string | null;
  reuseStatus?: 'completed' | 'active' | 'none' | 'stale' | 'unverified';
  requiresRescanConfirmation?: boolean;
  activeConflict?: boolean;
  fingerprint?: string;
};

export const isActiveGlossaryScan = (status: unknown): boolean =>
  ['admitting', 'queued', 'running', 'cancelling', 'settling'].includes(String(status || '').toLowerCase());

export const glossaryScanCost = (estimate: GlossaryScanEstimate | null, fresh = false): number | null => {
  const value = fresh ? estimate?.freshCreditCost : estimate?.creditCost;
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
};

// Keep this identity after an ambiguous network failure; a changed payload gets a new identity.
export type LaunchRequestIdentity = { signature: string; requestId: string };
export const launchRequestIdentity = (
  previous: LaunchRequestIdentity | null,
  payload: unknown,
): LaunchRequestIdentity => {
  const signature = JSON.stringify(payload);
  if (previous?.signature === signature) return previous;
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  return { signature, requestId: `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}` };
};
